import { useAthleteNavLegacyQuery } from "apps/web/src/types";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom-v5-compat";
import { Loading } from "shared-ui/global/Loading";

export const AthleteLegacyRouter = () => {
  const { athleteId: maybeAthleteId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const athleteId = maybeAthleteId || "";
  const { data, loading } = useAthleteNavLegacyQuery({
    variables: { athleteId },
    skip: !athleteId,
  });

  useEffect(() => {
    if (!loading && data) {
      const {
        athlete: {
          team: { id: teamId },
        },
      } = data;
      // Get the current legacy pathname, e.g. "/org/athletes/6951196b-e20e-4865-8f42-5623d89ba3a1/meal-plans/4215f9e2-9931-417c-b669-2490f15a13af"
      const currentPath = location.pathname;

      const athleteRoute = `/athletes/${athleteId}`;
      const athleteRouteIndex = currentPath.indexOf(athleteRoute);
      if (athleteRouteIndex !== -1) {
        const athleteSubRoute = currentPath.substring(athleteRouteIndex + athleteRoute.length);
        // Construct the new URL with /teams/{teamId}/ inserted before /athletes/{athleteId}
        const newPath = `/org/teams/${teamId}/athletes/${athleteId}${athleteSubRoute}`;
        // Navigate to the new path, replacing the current history entry
        navigate(newPath, { replace: true });
      }
    }
  }, [loading, data, athleteId, location.pathname, navigate]);

  return <Loading progressSize="lg" />;
};
